import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  inputDir?: "ltr" | "rtl";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputDir, style, ...props }, ref) => {
    return (
      <input
        type={type}
        dir={inputDir}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          inputDir === "ltr" && "text-left",
          className,
        )}
        ref={ref}
        style={style}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
